import createUseStyles from '@picsart/rc/create';
import { FontWeights } from '@picsart/rc/fonts';

const useTopBarStyles = createUseStyles(
  {
    root: {
      backgroundColor: 'var(--backgrounds-tint-1)',
      padding: '34px 0',
      borderBottom: '1px solid var(--absolute-white-base-action)',
      position: 'relative',
      textAlign: 'center',
      overflow: 'hidden',
      margin: '0',

      '&:before': {
        content: 'attr(data-watermark)',
        position: 'absolute',
        left: '50%',
        top: 0,
        transform: 'translateX(-50%)',
        color: 'var(--texts-tint-3)',
        opacity: 0.042,
        zIndex: 1,
        fontSize: 126,
        lineHeight: 1.45,
        pointerEvents: 'none',
        textTransform: 'uppercase',
        letterSpacing: 'normal',
      },
    },
    header: {
      lineHeight: 1,
      fontSize: 26,
      margin: '10px auto 0 auto',
      fontWeight: FontWeights.Bold,
    },
    subtitle: {
      color: 'var(--texts-tint-3)',
      fontWeight: FontWeights.Medium,
      fontSize: 10,
      lineHeight: 1,
      textTransform: 'uppercase',
    },
  },
  { name: 'top-bar' },
);

export default useTopBarStyles;
